module.exports = __webpack_public_path__ + "img/award (1).c13144f9.jpg";